import React from 'react';
import { Brain } from 'lucide-react';
export function Footer() {
  return <footer className="bg-cerebro-darker border-t border-slate-800 py-12" data-id="element-48">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-49">
        <div className="flex items-center gap-2" data-id="element-50">
          <Brain className="w-6 h-6 text-slate-500" data-id="element-51" />
          <span className="font-display font-bold text-lg text-slate-400" data-id="element-52">
            Cerebro Rápido
          </span>
        </div>

        <div className="flex gap-6 text-sm text-slate-500" data-id="element-53">
          <a href="#" className="hover:text-cerebro-blue transition-colors" data-id="element-54">
            Contacto
          </a>
          <a href="#" className="hover:text-cerebro-blue transition-colors" data-id="element-55">
            Términos
          </a>
          <a href="#" className="hover:text-cerebro-blue transition-colors" data-id="element-56">
            Privacidad
          </a>
        </div>

        <div className="text-sm text-slate-600" data-id="element-57">© 2025 Cerebro Rápido</div>
      </div>
    </footer>;
}